import React from "react";
import styled from "styled-components";

import { Fonts } from "assets/fonts";
import { Spinner } from "ui/components/styled";

const ViewWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background: ${(p) => p.theme.bgMediumContrast}80;
  z-index: 1001;
  cursor: progress;
  pointer-events: none;
`;

const MessageBlock = styled.div`
  display: flex;
  gap: 16px;
  width: 280px;
  padding: 16px 32px;
  background: ${(p) => p.theme.bgHighestContrast};
  box-shadow: 0 4px 8px rgb(28 40 53 / 12%);
  border-radius: 8px;
`;

const Title = styled.span`
  display: block;
  ${Fonts.semiBold_18};
`;

const Message = styled.span`
  ${Fonts.regular_14};
`;

type ViewType = "LOADING" | "SAVING";

const useCopyPerType = () => {
  return {
    LOADING: "Loading data",
    SAVING: "Saving",
  };
};

interface ReloadingViewProps {
  type?: ViewType;
}
export const ReloadingView = (props: ReloadingViewProps) => {
  const { type = "LOADING" } = props;
  const copyPerType = useCopyPerType();
  return (
    <ViewWrapper>
      <MessageBlock>
        <Spinner />
        <div>
          <Title>Please wait...</Title>
          <Message>{copyPerType[type]}</Message>
        </div>
      </MessageBlock>
    </ViewWrapper>
  );
};
